import {API_DRIVER} from "../config/axios";

const getBlogsRequestUrl = (endpointUrl: string) => {
    return `/api/blogs${endpointUrl}`
}

export interface IBlogCreateEdit {
    title_en: string
    title_mk: string
    title_al: string
    content_en: string
    content_mk: string
    content_al: string
    thumbnail: string
    minutes_read: number
}

export enum BlogSortOptions {
    CREATED_AT = "created_at",
    TIMES_READ = "times_read",
}

const BlogService = {
    fetchBlogs: (page: number, size: number, sort_by?: string, sort_order?: string) => {
        return API_DRIVER.get(getBlogsRequestUrl(``), {
            params: {
                limit: size,
                offset: page,
                sort_by,
                sort_order
            }
        })
    },
    fetchBlogById: (id: string) => {
        return API_DRIVER.get(getBlogsRequestUrl(`/${id}`))
    },
    createBlog: (body: IBlogCreateEdit) => {
        return API_DRIVER.post(getBlogsRequestUrl(``), body)
    },
    deleteBlog: (id: string) => {
        return API_DRIVER.delete(getBlogsRequestUrl(`/${id}`))
    },
    updateBlog: (id: string, body: IBlogCreateEdit) => {
        return API_DRIVER.put(getBlogsRequestUrl(`/${id}`), body)
    },
    incrementTimesRead: (id: string) => {
        return API_DRIVER.get(getBlogsRequestUrl(`/increment-times-read/${id}`))
    }
}

export default BlogService
